// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo_logo__3t_ht","logoWrapper":"Logo_logoWrapper__12r3G","expanded":"Logo_expanded__33t_g"};